// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DbxJ","col":"styles_col__Ho-HL"};